export const preferenceNames = {
  SelectedProfiles: 'Mca.SelectedProfiles',
  AdsDateRange: 'Mca.AdsDateRange',
  SocialReportDateRange: 'Mca.SocialReportDateRange',
  InboxActivityTypeFilter: 'Mca.InboxActivityTypeFilter',
  HomeReportDataRange: 'Mca.HomeReportDataRange',
  SignUpWizard: 'Mca.SignUpWizard',
  CampaignCreationWizards: 'Mca.CampaignCreationWizards',
  SignUpWizardV6: 'Mca.SignUpWizardV6',
  CampaignCreationWizardsV6: 'Mca.CampaignCreationWizardsV6',
  UpSignUpWizard: 'Up.SignUpWizard',
  UPCampaignCreationWizards: 'Up.CampaignCreationWizards',
  SmartPageSignupEntry: 'SmartPage.SignupEntry',
  SignUpWizardMode: 'Up.SignUpWizardMode',
  CalendarPostTypeFilter: 'Mca.CalendarPostTypeFilter',
  UpStepWizardStep: 'Up.StepWizardStep',
  SubAdsWizardStep: 'SubAds.WizardStep',
  UPWizardTermsAndCondition: 'UP.TermsAndCondition',
  SubAdsWizardTermsAndCondition: 'SubAds.TermsAndCondition',
  UpSpecialCategoryLastModifyTime: 'Up.SpecialCategoryLastModifyTime',
  UpBudgetSuggestionsLastModifyTime: 'Up.BudgetSuggestionsLastModifyTime',
  UpSignUpFlowId: 'Up.SignUpFlowId',
  UpMobileAppPrompt: 'Up.MobileAppPrompt',
  UpChatBubbleRejectionInfo: 'Up.ChatBubbleRejectionInfo',
};
